import React from 'react';

import {
  FlexLayout,
  Link,
  TextLabel
} from '@nutanix-ui/prism-reactjs';

export default [{
  key: '1',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>NTNX-demo-files-3</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">19.63%</TextLabel>
}, {
  key: '2',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>win</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">17.11%</TextLabel>
}, {
  key: '3',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>NTNX-demo-files-1</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">17.09%</TextLabel>
}, {
  key: '4',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>NTNX-demo-files-2</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">16.38%</TextLabel>
}, {
  key: '5',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>Demo PC</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">10.35%</TextLabel>
}, {
  key: '6',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>demo-obj-a19a92-default-0</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">8.53%</TextLabel>
}, {
  key: '7',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>testezilmar</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">8.32%</TextLabel>
}, {
  key: '8',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>demo-obj-a19a92-default-2</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">6.59%</TextLabel>
}, {
  key: '9',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>karbon-ms-test-45ed65-k8s-master-0</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">5.27%</TextLabel>
}, {
  key: '10',
  name: <FlexLayout flexDirection="column" itemSpacing="10px" padding="10px-0px">
    <Link>karbon-dev-k8s-946619-k8s-master-0</Link>
    <TextLabel>DEMO-AHV</TextLabel>
  </FlexLayout>,
  percentage: <TextLabel type="primary">5%</TextLabel>
}];
